import { Box, Stack } from '@mui/material'
import React from 'react'
import SidebarSlidingIndicator from './SidebarSlidingIndicator'
import SidebarCollapsibleSection from './SidebarCollapsibleSection'
import {
  CollapsibleSectionConfig,
  CollapseDirection,
  SidebarSectionKey,
} from '../../store/types/components/sidebar/sidebarTypes'
import { SidebarSection } from './sidebarUtils'
import { SIDEBAR_ITEM_HEIGHT } from './sidebarConstants'

type SidebarExpandedContentProps = {
  sections: CollapsibleSectionConfig[]
  visibleLinksCount: number
  isCollapsing: boolean
  indicatorRef: React.RefObject<HTMLDivElement>
  linkRefs: React.MutableRefObject<{ [index: number]: HTMLDivElement | null }>
  onToggleSection: (section: SidebarSection) => void
  onCollapseStart: (section: SidebarSectionKey, direction: NonNullable<CollapseDirection>) => void
  onCollapseComplete: () => void
}

const SidebarExpandedContent = ({
  sections,
  visibleLinksCount,
  isCollapsing,
  indicatorRef,
  linkRefs,
  onToggleSection,
  onCollapseStart,
  onCollapseComplete,
}: SidebarExpandedContentProps) => (
  <Stack direction="column" gap={0.5} sx={{ alignItems: 'flex-start', width: '100%' }}>
    <Box sx={{ position: 'relative', minHeight: visibleLinksCount * SIDEBAR_ITEM_HEIGHT, width: '100%' }}>
      <SidebarSlidingIndicator isCollapsing={isCollapsing} open ref={indicatorRef} />
      {sections.map(section => (
        <SidebarCollapsibleSection
          key={section.key}
          config={section}
          isSidebarExpanded
          isCollapsing={isCollapsing}
          linkRefs={linkRefs}
          onToggleSection={onToggleSection}
          onCollapseComplete={onCollapseComplete}
          onCollapseStart={onCollapseStart}
        />
      ))}
    </Box>
  </Stack>
)

export default SidebarExpandedContent
